import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import HomePage from "./components/HomePage";
import ImpressumPage from "./components/ImpressumPage";
import AGBPage from "./components/AGBPage";
import DatenschutzPage from "./components/DatenschutzPage";
import AVVPage from "./components/AVVPage";
import NachhaltigkeitPage from "./components/NachhaltigkeitPage";
import RiskRewardGame from "./components/RiskRewardGameNew";
import DemoRequestPage from "./components/DemoRequestPage";
import NotFoundPage from "./components/NotFoundPage";
import { Toaster } from "./components/ui/sonner";
import CookieBanner from "./components/CookieBanner";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/impressum" element={<ImpressumPage />} />
            <Route path="/agb" element={<AGBPage />} />
            <Route path="/datenschutz" element={<DatenschutzPage />} />
            <Route path="/avv" element={<AVVPage />} />
            <Route path="/nachhaltigkeit" element={<NachhaltigkeitPage />} />
            <Route path="/risk-reward" element={<RiskRewardGame />} />
            <Route path="/demo-anfrage" element={<DemoRequestPage />} />
            {/* Catch-all route for 404 - must be last */}
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </BrowserRouter>
        <Toaster />
        <CookieBanner />
      </div>
    </HelmetProvider>
  );
}

export default App;
